import { apiClient } from "./ApiClient";
import { IDriver } from "../classes/Domain";

export default class DriversApiClient {

    updateDriver(quoteUid: string, driver: IDriver, quoteStep: string) {
        return apiClient.instance.request({
            url: '/quote/update-driver',
            data: {
                quoteUid,
                driver,
                quoteStep
            }
        });
    }

    getOccupations(query: string) {
        return apiClient.instance.request({
            url: '/quote/get-occupations?query=' + query,
            method: 'get'
        });
    }
}